export const isBrowser = () => typeof window !== 'undefined'

export const getParams = (href) => {
  const { searchParams } = new URL(href)
  return Object.fromEntries(searchParams)
}

export type Video = Record<string, any>
export type RelatedResource = Record<string, any>
